// Returns HTTP status code from diverse error shapes (Axios-like or custom)
export const getHttpStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const maybe = error as { status?: number; response?: { status?: number } };
  return maybe.status ?? maybe.response?.status;
};
